import { apiClient } from '@/shared/api';

import type {
  CatalogFeedColumnMapping,
  CatalogFeedColumnMappingRequest,
  CatalogFeedFile,
} from '../model/types';

const BASE = '/api/v1/catalog/import/feed';

/** Upload the tenant's own custom-format feed file for asynchronous processing. */
export const uploadCatalogFeedFile = async (file: File): Promise<CatalogFeedFile> => {
  const form = new FormData();
  form.append('file', file);
  const { data } = await apiClient.post<CatalogFeedFile>(`${BASE}/files`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const getCatalogFeedFile = async (fileId: string): Promise<CatalogFeedFile> =>
  (await apiClient.get<CatalogFeedFile>(`${BASE}/files/${fileId}`)).data;

export const reprocessCatalogFeedFile = async (fileId: string): Promise<CatalogFeedFile> =>
  (await apiClient.post<CatalogFeedFile>(`${BASE}/files/${fileId}/reprocess`)).data;

/** Escape hatch: force a re-publish of a single product to Kafka (support/ops use). */
export const exportCatalogFeedProduct = async (productArticle: string): Promise<void> => {
  await apiClient.post(`${BASE}/export/products/${encodeURIComponent(productArticle)}`);
};

/** Escape hatch: force a re-publish of every product to Kafka (support/ops use). */
export const exportAllCatalogFeedProducts = async (): Promise<void> => {
  await apiClient.post(`${BASE}/export/products`);
};

export const getCatalogFeedColumnMapping = async (): Promise<CatalogFeedColumnMapping> =>
  (await apiClient.get<CatalogFeedColumnMapping>(`${BASE}/column-mapping`)).data;

export const createCatalogFeedColumnMapping = async (
  body: CatalogFeedColumnMappingRequest,
): Promise<CatalogFeedColumnMapping> =>
  (await apiClient.post<CatalogFeedColumnMapping>(`${BASE}/column-mapping`, body)).data;

export const updateCatalogFeedColumnMapping = async (
  body: CatalogFeedColumnMappingRequest,
): Promise<CatalogFeedColumnMapping> =>
  (await apiClient.put<CatalogFeedColumnMapping>(`${BASE}/column-mapping`, body)).data;
